import styled from 'styled-components';
import { Text } from '../Text';
import { withMargins } from '../../mixins';
const borderColor = ({ checked, hover, error, outline = false }) => {
    if (error)
        return 'var(--radio-border-color-error)';
    if (checked && hover)
        return 'var(--radio-background-color-checked-hover)';
    if (checked)
        return 'var(--radio-background-color-checked)';
    if (hover)
        return 'var(--radio-border-color-hover)';
    if (outline)
        return 'var(--radio-border-color-hover)';
    return 'var(--radio-border-color-hover)';
};
export const Label = styled(Text.BodyMedium) `
  color: ${({ outline, checked }) => (outline && checked ? `var(--color-secondary-100)` : `var(--radio-font-color)`)};
`;
export const Radio = styled.label `
  width: fit-content;
  display: ${({ display = 'inline' }) => (display === 'block' ? 'flex' : 'inline-flex')};
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: none;

  ${({ disabled }) => disabled &&
    `
      opacity: var(--opacity-medium);
      cursor: not-allowed;
    `};

  ${({ outline, checked, error }) => outline
    ? `
      padding: var(--spacing-1) var(--spacing-2);
      border-color: ${borderColor({ checked, hover: false, error, outline: true })};
      border-width: var(--border-width-hairline);
      border-radius: var(--border-radius-sm);
      border-style: solid;

      &:hover {
        border-color: ${borderColor({ checked, hover: true, error, outline: true })};

        ${checked &&
        `
         ${Label} {
          color: var(--color-secondary-120);
        }`}
      }
    `
    : `
      border-radius: var(--border-radius-pill);
    `};

  &:hover {
    ${({ checked }) => checked &&
    `
      svg {
        color: var(--color-secondary-120);
      }
    `}
  }

  ${withMargins}
`;
export const RadioContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: fit-content;
`;
export const RadioContent = styled.div `
  display: flex;
`;
export const RadioNativeInput = styled.input `
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
`;
export const RadioInput = styled.span `
  position: relative;
  min-width: 24px;
  width: 24px;
  max-width: 24px;
  min-height: 24px;
  height: 24px;
  max-height: 24px;
  border-radius: var(--border-radius-pill);
  padding: var(--spacing-0-25);
  :focus-within {
    outline: var(--color-neutral-130) solid var(--border-width-thin);
  }
`;
export const RadiotStylizedInput = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ error }) => error ? 'var(--radio-background-color-error)' : 'var(--radio-background-color-base)'};
  border-color: ${({ checked, error }) => borderColor({ checked, hover: false, error })};
  border-width: ${({ checked }) => (checked ? 'var(--border-width-thin)' : 'var(--border-width-hairline)')};
  border-radius: var(--border-radius-pill);
  border-style: solid;

  ${Radio}:hover:not([disabled]) & {
    background-color: var(--radio-background-color-hover);
    border-color: ${({ checked, error }) => borderColor({ checked, hover: true, error })};
    border-width: var(--border-width-thin);
  }

  ${Radio}:active:not([disabled]) & {
    transform: scale(0.92);
  }

  ::after {
    content: '';
    width: 12px;
    height: 12px;
    background-color: ${({ checked }) => (checked ? 'var(--radio-background-color-checked)' : 'transparent')};
    border-radius: var(--border-radius-pill);

    ${Radio}:hover:not([disabled]) & {
      background-color: ${({ checked }) => (checked ? 'var(--radio-background-color-checked-hover)' : 'transparent')};
    }
  }
`;
export const LabelWrapper = styled.span `
  margin-left: var(--spacing-1);
`;
export const RadioCustomIcon = styled.span `
  margin-left: var(--spacing-1);
  display: flex;

  ${({ checked }) => checked &&
    `
    svg {
      color: var(--color-secondary-100)
    }
  `}
`;
export const RadioErrorMessage = styled.div `
  display: flex;
  align-items: center;
  column-gap: 4px;
  color: var(--color-feedback-error-100);
  margin-top: var(--spacing-0-5);
`;
